import {inject} from "@angular/core";
import {UserService} from "../../service/user.service";
import {Screen} from "../../shared/enums/role.enum";
import {ApresentaHubPipe} from "./apresenta-hub.pipe";
import {DesabilitaFrameworkNoHubPipe} from "./desabilita-framework-no-hub.pipe";
import {Router} from "@angular/router";

export const AuthGuard = (roles?: Screen | Screen[], avoidHubValidation?: boolean, allowedUserTypes?: string[]) => {
  const authService = inject(UserService);
  const router = inject(Router);

  if (!roles)
    roles = [];
  else if (!Array.isArray(roles))
    roles = [roles];

  if (!authService.isLogged()) {
    authService.efetuarLogout();
    return false;
  }

  if (roles.length > 0 && authService.checkForcePassword()) {
    authService.redirectToChangePassword();
    return false;
  }

  const hasUserType = allowedUserTypes ? authService.canActivateByUserType(allowedUserTypes) : false;

  if (roles.length > 0 && !hasUserType && !authService.hasPermission(roles)) {
    // authService.efetuarLogout();
    authService.redirectToHome();
    return false;
  }

  const permiteAcessoHub = new ApresentaHubPipe().transform(authService);
  const desabilidaFrameworkNoHub = new DesabilitaFrameworkNoHubPipe().transform(authService);

  if (avoidHubValidation) {
    return true;
  }
  console.log(!(permiteAcessoHub && desabilidaFrameworkNoHub))
  return !(permiteAcessoHub && desabilidaFrameworkNoHub);
};
